import React from 'react';

import { Icon } from '~/components/common';

import starFillIcon from '~/../symbols/star-fill.svg';
import starHalfIcon from '~/../symbols/star-half.svg';
import starBorderIcon from '~/../symbols/star-border.svg';
export default function ConversionFlowCustomerRating({ klantenvertellenScore }) {

    const averageRating = klantenvertellenScore || 0;
    const fullStars = Math.floor(Math.round(averageRating) / 2);
    const halfStars = Math.round(averageRating) % 2;
    const emptyStars = 5 - fullStars - halfStars;

    const renderStars = (type, count) => {
        const stars = [];
        for (let i = 0; i < count;) {
            stars.push(
                <span key={i} className="text-primary">
                    <Icon
                        url={type}
                        size={24}
                    />
                </span>
            );
            i++;
        }
        return stars;
    };

    return (
        <>
            <div>
                {fullStars > 0 && renderStars(starFillIcon, fullStars)}
                {halfStars > 0 && renderStars(starHalfIcon, halfStars)}
                {emptyStars > 0 && renderStars(starBorderIcon, emptyStars)}
            </div>
            <p className="text--16 font-weight-bold">We krijgen een {averageRating}</p>
        </>

);
}
